import React from 'react';
import { MessageStatus as MessageStatusType } from '../../../../../../../store/chat/types';
import { Text } from '../../../../../../../components/Typography/Typography';
import styles from './MessageStatus.module.scss';

interface MessageStatusProps {
  status: MessageStatusType;
}

const MessageStatus: React.FC<MessageStatusProps> = ({ status }) => {
  let statusText = '';
  let statusClass = '';

  switch (status) {
    case MessageStatusType.Sending:
      statusText = 'Sending to Enlo...';
      statusClass = styles.sent;
      break;
    case MessageStatusType.Sent:
      statusText =
        'Sent to Enlo. You can now open a new chat or navigate away while Enlo works on this one.';
      statusClass = styles.sent;
      break;
    case MessageStatusType.Seen:
      statusText = 'Seen by Enlo';
      statusClass = styles.seen;
      break;
    default:
      return null;
  }

  return (
    <div className={`${styles.statusContainer} ${statusClass}`}>
      <Text size="small" weight="regular" className={styles.statusText}>
        {statusText}
      </Text>
    </div>
  );
};

export default MessageStatus;
